import React, { useState } from 'react';
import JobCompletionModal from '../components/JobCompletionModal';

// Demo page to showcase the Job Completion Modal
const DemoCompletionForm = () => {
  const [showModal, setShowModal] = useState(true);
  const [serviceType, setServiceType] = useState('cleaning'); // 'cleaning' or 'private_concierge'
  
  // Mock booking data for demo
  const mockBooking = {
    id: 'demo-booking-123',
    service_name: serviceType === 'private_concierge' ? 'Premium Concierge Service' : 'Deep House Cleaning',
    service_type: serviceType,
    customer_name: 'John Smith',
    address: '123 Oak Street',
    city: 'Greenville',
    state: 'NC'
  };

  const handleSubmit = () => {
    alert('Form submitted! In production, this would clock you out.');
    setShowModal(false);
  };

  return (
    <div className="min-h-screen bg-[var(--background-subtle)] p-8">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-3xl font-bold mb-4">Job Completion Form Demo</h1>
        <p className="text-[var(--text-secondary)] mb-6">
          This is a demonstration of the Job Completion Form that workers see when they click "Clock Out"
        </p>
        
        {/* Service Type Toggle */}
        <div className="flex justify-center gap-4 mb-8">
          <button
            onClick={() => { setServiceType('private_concierge'); setShowModal(true); }}
            className={`px-6 py-3 rounded-lg font-medium transition ${
              serviceType === 'private_concierge' 
                ? 'bg-[#E6C965] text-white' 
                : 'bg-[var(--background-paper)] text-[#D4AF37] border border-blue-600'
            }`}
          >
            Errands/Tasks Service (3 Steps - No Photos)
          </button>
          <button
            onClick={() => { setServiceType('cleaning'); setShowModal(true); }}
            className={`px-6 py-3 rounded-lg font-medium transition ${
              serviceType === 'cleaning' 
                ? 'bg-[var(--success)] text-white' 
                : 'bg-[var(--background-paper)] text-[var(--success)] border border-green-600'
            }`}
          >
            Cleaning Service (4 Steps - With Photos)
          </button>
        </div>
        
        {!showModal && (
          <button
            onClick={() => setShowModal(true)}
            className="px-6 py-3 bg-rose-600 text-white rounded-lg font-medium hover:bg-rose-700"
          >
            Show Job Completion Form
          </button>
        )}
      </div>

      {showModal && (
        <JobCompletionModal
          key={serviceType} // Force remount when service type changes
          booking={mockBooking}
          onClose={() => setShowModal(false)}
          onSubmit={handleSubmit}
          currentLocation={{ lat: 35.6127, lng: -77.3664 }}
        />
      )}
    </div>
  );
};

export default DemoCompletionForm;
